var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketShoppingSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 2.33101C17.3534 1.54742 17.0456 0.58453 16.2629 0.179452C15.4802 -0.225626 14.5035 0.0798427 14.0954 0.856796L7.86722 12.7502H2.14074C0.956643 12.7502 0 13.6998 0 14.8752C0 16.0505 0.956643 17.0002 2.14074 17.0002L5.61275 30.7795C6.08773 32.672 7.80032 34.0002 9.76713 34.0002H28.7662C30.733 34.0002 32.4456 32.672 32.9206 30.7795L36.3926 17.0002C37.5767 17.0002 38.5333 16.0505 38.5333 14.8752C38.5333 13.6998 37.5767 12.7502 36.3926 12.7502H30.6661L24.4379 0.856796C24.0298 0.0798427 23.0598 -0.225626 22.2704 0.179452C21.481 0.58453 21.18 1.54742 21.588 2.33101L27.0469 12.7502H11.4864L16.9453 2.33101ZM12.8444 20.1877V26.5627C12.8444 27.147 12.3628 27.6252 11.7741 27.6252C11.1854 27.6252 10.7037 27.147 10.7037 26.5627V20.1877C10.7037 19.6033 11.1854 19.1252 11.7741 19.1252C12.3628 19.1252 12.8444 19.6033 12.8444 20.1877ZM19.2667 19.1252C19.8554 19.1252 20.337 19.6033 20.337 20.1877V26.5627C20.337 27.147 19.8554 27.6252 19.2667 27.6252C18.678 27.6252 18.1963 27.147 18.1963 26.5627V20.1877C18.1963 19.6033 18.678 19.1252 19.2667 19.1252ZM27.8296 20.1877V26.5627C27.8296 27.147 27.348 27.6252 26.7593 27.6252C26.1706 27.6252 25.6889 27.147 25.6889 26.5627V20.1877C25.6889 19.6033 26.1706 19.1252 26.7593 19.1252C27.348 19.1252 27.8296 19.6033 27.8296 20.1877Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.5333,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketShoppingSolid);
export default __webpack_public_path__ + "static/media/basket-shopping-solid.795f907fe12097b7e38c950258e73098.svg";
export { ForwardRef as ReactComponent };